export const currecyFormat = (currency, { type = 'ru-RU', ...rest } = {}) =>
  new Intl.NumberFormat(type, { currency: 'RUB', minimumFractionDigits: 2, ...rest }).format(
    currency
  )
